"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndexDbConfigurationManager = void 0;
const tsyringe_1 = require("tsyringe");
const globalSymbols_1 = require("../../../globalSymbols");
const ConfigurationObject_1 = require("../ConfigurationObject");
const MMMConfigurationDatabase_1 = require("./MMMConfigurationDatabase");
let IndexDbConfigurationManager = class IndexDbConfigurationManager {
    constructor(logger, database) {
        this.logger = logger;
        this.database = database;
    }
    getConfiguration(name) {
        return __awaiter(this, void 0, void 0, function* () {
            this.logger.log(`[Configuration Manager]: Getting configuration object for ${name}`);
            this.database.configuration.mapToClass(ConfigurationObject_1.ConfigurationObject);
            let configObj = yield this.database.configuration.where("Name").equalsIgnoreCase(name).first();
            return configObj.toObject();
        });
    }
    saveConfiguration(name, configObj) {
        return __awaiter(this, void 0, void 0, function* () {
            this.logger.log(`[Configuration Manager]: Saving configuration object for ${name}`);
            let configObject = new ConfigurationObject_1.ConfigurationObject();
            configObject.Name = name;
            configObject.Value = configObj;
            this.database.configuration.put(configObject);
        });
    }
    configurationExists(name) {
        return __awaiter(this, void 0, void 0, function* () {
            this.logger.log(`[Configuration Manager]: Checking if configuration object exists for ${name}`);
            if ((yield this.database.configuration.where("Name").equalsIgnoreCase(name).count()) >= 1) {
                this.logger.log(`[Configuration Manager]: Config object "${name}" exist.`);
                return true;
            }
            else {
                this.logger.logWarn(`[Configuration Manager]: Config object "${name}" does not exist.`);
                return false;
            }
        });
    }
};
IndexDbConfigurationManager = __decorate([
    tsyringe_1.injectable(),
    __param(0, tsyringe_1.inject(globalSymbols_1.TLogger)),
    __metadata("design:paramtypes", [Object, MMMConfigurationDatabase_1.MMMConfigurationDatabase])
], IndexDbConfigurationManager);
exports.IndexDbConfigurationManager = IndexDbConfigurationManager;
//# sourceMappingURL=IndexDbConfigurationManager.js.map